<div class="login_page">
  <div class="container-fluid">
    <div class="login-wrapper row">
      <div id="login" class="login loginpage col-lg-offset-4 col-md-offset-3 col-sm-offset-3 col-xs-offset-0 col-xs-12 col-sm-6 col-lg-4">
        <h1><a title="Please enter the two factor code emailed to you" tabindex="-1">Portal Admin</a></h1>

        <form name="tfaForm" id="tfaForm" [formGroup]="tfaForm" (ngSubmit)="login(tfaForm.value)" autocomplete="off">
          <!--<div class="label-danger row message" *ngIf="errorMessage">
            <label> {{errorMessage}}</label>
          </div>-->


          <p>
            <label for="tfa">
              Please enter the two factor code emailed to you<br />
              <input type="text" formControlName="tfa" id="tfa" class="input" name="tfa" size="20" />
              @if(tfaForm.value.tfa.invalid&&tfaForm.value.tfa.touched){
              <em class="text-danger">Required</em>
              }
            </label>
          </p>


          <p class="submit">
            <input type="submit" name="submit" id="submit" class="btn btn-accent btn-block" value="Sign In" />
          </p>

        </form>
      </div>
    </div>
  </div>
</div>
